// extracted by mini-css-extract-plugin
export default {"nweaSelectPanel":"ald_select__nweaSelectPanel__ORIKe","nweaSelectLabel":"ald_select__nweaSelectLabel__G7pZL","nweaSelect":"ald_select__nweaSelect__By5wA"};